import { render } from "./MaterialCategory.vue?vue&type=template&id=c4cded32&scoped=true"
import script from "./MaterialCategory.vue?vue&type=script&lang=js"
export * from "./MaterialCategory.vue?vue&type=script&lang=js"

import "./MaterialCategory.vue?vue&type=style&index=0&id=c4cded32&scoped=true&lang=css"

import exportComponent from "/vercel/path0/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c4cded32"]])

export default __exports__